// eslint-disable-next-line import/prefer-default-export
export const getCompactMode = () => JSON.parse(localStorage.getItem('vtcompactMode'))
